import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure48 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
marginLeft: 180,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '600px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

colors: ['#deebf7', '#00b0f0'],

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
marker: {
symbol: 'circle',
enabled: false,
states: {
	    hover: {
			   enabled: true,
			   radius: 5
		   }
    }
}
}
},

exporting: {
enabled: false
},

xAxis: [{
categories: [
	     "Monde",
	     "Asie centrale et Asie du Sud",
	     "Asie centrale",
	     "Asie du Sud",
	     "Asie de l’Est et Asie du Sud-Est",
	     "Asie de l’Est",
	     "Asie du Sud-Est",
	     "Amérique du Nord et Europe ",
	     "Europe",
	     "Amérique du Nord",
	     "Amérique latine et Caraïbes",
	     "Océanie",
	     "Océanie (à l’exception de l’Australie et de la Nouvelle-Zélande)",
	     "Australie et Nouvelle-Zélande",
	     "Afrique du Nord et Asie de l’Ouest",
	     "Afrique du Nord",
	     "Asie de l’Ouest",
	     "Afrique subsaharienne",
],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
useHTML: true,
tickLength: 16,
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
}
},
}],
yAxis: [{
labels: {
format: '{value}',
style: {
	   fontWeight: 'normal',
	   color: '#999999',
	   fontSize: '12px'
   },
},
max: 140,
min: 0,
tickInterval: 20,
gridLineWidth: 0,
title: {
text: null,
style: {
	 color: Highcharts.getOptions().colors[1]
 }
	},
	opposite: true,
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
style: {
padding: 0
}
},
legend: {
enabled: false,
},

series: [
{
name: '2015',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: false,
style: {
	  fontWeight: 'normal',
	  textOutline: false,
	  color: '#999999',
	  fontSize: '12px'
  }
},
data: [
       18.03,
       71.27,
       76.83,
       78.05,
       30.83,
       45.66,
       20.17,
       12.29,
       8.36,
       20.17,
       5.75,
       2.83,
       0.16,
       5.24,
       71.21,
       104.68,
       57.42,
       5.9,
],
},
{
name: '2020',
tooltip: {
valueSuffix: '%'
},
dataLabels: {
enabled: false,
style: {
	  fontWeight: 'normal',
	  textOutline: false,
	  color: '#999999',
	  fontSize: '12px'
  }
},
data: [
       18.24,
       71.13,
       79.96,
       77.49,
       30.36,
       44.06,
       20.42,
       12.45,
       8.38,
       20.19,
       5.98,
       2.74,
       0.16,
       5.6,
       83.94,
       120.55,
       68.87,
       6.18,
]
}]
}
